<template>
  <div class="app-dropzone">
    <div
        v-show="this.filelist.length < 1"
        class="well well-dropzone"
        :class="{ 'dragover': dragIsHover }"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
    >
      <div>
        <input
            type="file"
            multiple
            name="files[]"
            id="assetsFieldHandle"
            class="d-none"
            v-show="false"
            @change="onChange"
            ref="file" />

        <label for="assetsFieldHandle" class="cursor-pointer">
          <div v-show="dragIsHover">
            <span>Laat los om te uploaden...</span>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zm-9-3.82l-2.09-2.09L6.5 13.5 10 17l6.01-6.01-1.41-1.41z"/></svg>
          </div>
          <div v-show="!dragIsHover">
            <span>Sleep bestanden of klik hier...</span>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"/></svg>
          </div>
        </label>
      </div>
    </div>

    <document-list
        :files="filelist"
        :errors="errors"
        :sharable="sharable"
        v-model="filelistInfo"
        @remove="remove">
    </document-list>

    <label for="assetsFieldHandle" class="btn-upload-more"  v-if="filelist.length && filelist.length < (maxFiles + 2)">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"/></svg>
      <strong>meer bestanden uploaden...</strong>
    </label>
  </div>
</template>

<script>
export default {
  name: "AppDropzone",

  props: {
    errors: {
      type: Object,
      default: {},
    },

    sharable: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      filelistInfo: {},
      dragIsHover: false,
      filelist: [],
      uploadErrors: {},
      maxFiles: 20,
    }
  },

  watch: {
    errors: {
      deep: true,
      immediate: true,
      handler() {
        this.uploadErrors = this.errors;
      }
    },
  },

  methods: {
    onChange(event) {
      if (event) {
        const eventFiles = event.target.files ? event.target.files : event.dataTransfer.files;
        this.filelist = [...this.filelist, ...eventFiles];
        event.target.value = '';
      }
      this.uploadErrors = [];
      this.$emit('change', this.filelist);
    },

    remove(i) {
      this.filelist.splice(i, 1);
      this.filelistInfo.names.splice(i, 1);
      this.uploadErrors = [];
    },

    dragover(event) {
      event.preventDefault();

      this.dragIsHover = true;
    },

    dragleave() {
      this.dragIsHover = false;
    },

    drop(event) {
      event.preventDefault();

      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(event);
      this.dragIsHover = false;
    },

    hasError(index) {
      return _.get(this.uploadErrors, `files.${index}`, false);
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/AppDropzone.vue